// removed by extract-text-webpack-plugin
module.exports = {"Quiz":"_141rKXBTnw-kqdPbjFluHy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Quiz/styles.css
// module id = 686
// module chunks = 0